import { render } from "./ListEmptyView.vue?vue&type=template&id=6f3269f8&scoped=true"
import script from "./ListEmptyView.vue?vue&type=script&lang=js"
export * from "./ListEmptyView.vue?vue&type=script&lang=js"

import "./ListEmptyView.vue?vue&type=style&index=0&id=6f3269f8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f3269f8"]])

export default __exports__